'use es6';

import { Map as ImmutableMap } from 'immutable';
import * as http from 'reporting-data/request/http';
import { AGGREGATION_PROPS, DEFAULT_X_FIELD, DEFAULT_Y_FIELD } from './constants';
import { SEARCH } from 'reporting-data/constants/configTypes';
import { translateFilters, deleteMetricTypes, isSearch, isTable, getQuery } from '../lib/salesAnalytics/helpers';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import resolveProperties from '../lib/salesAnalytics/resolveProperties';
import { BREAKDOWNS } from '../lib/salesExplorer';
import generateReferences from '../lib/salesAnalytics/generateReferences';
import { getDrilldownFields } from '../lib/salesAnalytics/drilldownColumns';
const addMissingStart = breakdowns => {
  const isStartMissing = !breakdowns.some(breakdown => breakdown.get(DEFAULT_X_FIELD) === BREAKDOWNS.START);
  return isStartMissing ? breakdowns.unshift(ImmutableMap({
    [DEFAULT_X_FIELD]: BREAKDOWNS.START,
    [DEFAULT_Y_FIELD]: 0,
    count: 0
  })) : breakdowns;
};
const addMissingEnd = breakdowns => {
  const isEndMissing = !breakdowns.some(breakdown => breakdown.get(DEFAULT_X_FIELD) === BREAKDOWNS.END);
  return isEndMissing ? breakdowns.push(ImmutableMap({
    [DEFAULT_X_FIELD]: BREAKDOWNS.END,
    [DEFAULT_Y_FIELD]: 0,
    count: 0
  })) : breakdowns;
};
const resolveData = report => report.getIn(['config', 'configType']) === SEARCH ? http.post('/sales-reporting/waterfall/breakdown-objects', {
  query: getQuery(report),
  data: {
    config: deleteMetricTypes(report).get('config').delete('offset'),
    offset: report.getIn(['config', 'offset'])
  }
}).then(response => ({
  report,
  response
})) : http.post('/sales-reporting/waterfall/breakdown-amounts', {
  query: Object.assign({}, getQuery(report), {
    includeNetPipelineImpact: true
  }),
  data: report.get('config')
}).then(response => ({
  report,
  response
}));
const transformSearch = ({
  report,
  response
}) => {
  const objects = response.toJS().objects.map(({
    object: {
      properties: objectProps,
      objectId
    },
    explanation
  }) => Object.keys(objectProps).reduce((collect, key) => Object.assign({}, collect, {
    objectId,
    [key]: objectProps[key].value
  }), explanation));
  const datasets = ImmutableMap({
    primary: Dataset({
      data: objects,
      paginationSize: response.get('total')
    })
  });
  return {
    report,
    response,
    datasets
  };
};
const transformAggregation = ({
  report,
  response
}) => {
  const endToEndAmountChange = response.get('endToEndAmountChange');
  const endToEndAmountChangePercent = response.get('endToEndAmountChangePercent');
  const breakdowns = response.get('breakdowns').update(addMissingStart).update(addMissingEnd).map(breakdown => isTable(report) || breakdown.get('isPositiveBreakdown') || breakdown.get('isTerminalBreakdown') ? breakdown : breakdown.set(DEFAULT_Y_FIELD, -1 * breakdown.get(DEFAULT_Y_FIELD, 0)));
  const summaryData = [{
    metrics_primary: endToEndAmountChange,
    metrics_secondary: endToEndAmountChangePercent
  }];
  return {
    report,
    response,
    datasets: ImmutableMap({
      primary: Dataset({
        data: breakdowns
      }),
      summary: Dataset({
        data: summaryData
      })
    })
  };
};
export default (report => isSearch(report) ? translateFilters(report).then(resolveData).then(transformSearch).then(resolveProperties(getDrilldownFields(report))).then(generateReferences).then(({
  datasets
}) => datasets.map(dataset => ImmutableMap({
  data: dataset
}))) : translateFilters(report).then(resolveData).then(transformAggregation).then(resolveProperties(AGGREGATION_PROPS)).then(generateReferences).then(({
  datasets
}) => datasets.map(dataset => ImmutableMap({
  data: dataset
}))));